import definitionReducer from './definitionReducer'
import uiReducer from './uiReducer'

export default {
  definition: definitionReducer,
  ui: uiReducer,
}
